export const environment = {
    languages: ['en', 'fr'],
    production: true,
    apiUrl: '/api',
    googleClientId: '601673632787-sotve9gte3o5gjv235dtmqodmbhaaqla.apps.googleusercontent.com',
  };